import { useEffect, useState } from "react"

import { usePaymentContext } from "modules/Payment/PaymentContext"
import { getPrice } from "modules/Payment/common/utils"
import { CURRENCY } from "utils/constants"

export function useGetPrice(): [number | undefined, number | undefined] {
    const [{ bookingDetails, selectedDiscount, currency }] = usePaymentContext()
    const [price, setPrice] = useState<number | undefined>()
    const [newPrice, setNewPrice] = useState<number | undefined>()

    useEffect(() => {
        if (bookingDetails.psy) {
            const discountId = selectedDiscount ?? bookingDetails.discounted ?? undefined
            if (discountId !== undefined) {
                void getPrice(bookingDetails.booking_id, discountId)
                    .then((data) => {
                        setNewPrice(currency === CURRENCY.RUB ? data.price : data.price_usd)
                    })
                    .catch(undefined)
            }
            void getPrice(bookingDetails.booking_id, undefined)
                .then((data) => {
                    const price = currency === CURRENCY.RUB ? data.price : data.price_usd
                    setPrice(price)
                    if (discountId !== undefined) return
                    setNewPrice(price)
                })
                .catch(undefined)
        } else {
            setNewPrice(price)
        }
    }, [selectedDiscount, bookingDetails.booking_id, currency])
    return [price, newPrice]
}
